
import Vue from 'vue';

export default Vue.extend({
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
    titleContainerStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasSideContent(): boolean {
      return !!this.$slots['side-content'];
    },
  },
});
